"use client";
import { motion } from "motion/react";
import { Icon } from "@iconify/react";
import { sectorsData } from "@/lib/about-data";
import { containerVariants, itemVariants } from "@/utils/animations";
import Link from "next/link";

export default function IndustryVerticals() {
  return (
    <section className="py-24 bg-midnight_text dark:bg-black/40 text-foottext relative overflow-hidden transition-colors duration-300">
      <div className="max-w-[83.75rem] mx-auto px-6 relative z-10">
        <div className="mb-16 md:flex justify-between items-end">
          <div>
            <span className="text-primary font-bold tracking-widest text-sm uppercase mb-2 block">
              Industries
            </span>
            <h2 className="text-40 font-bold mb-4 text-white">
              Core Sectors & Expertise
            </h2>
            <p className="text-foottext max-w-xl text-lg">
              We serve a broad section of industries including Oil Refineries,
              Pharmaceuticals, Chemical Engineering, and Public Safety.
            </p>
          </div>
        </div>

        <motion.div
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6"
        >
          {sectorsData.map((sector, index) => (
            <motion.div
              key={index}
              variants={itemVariants}
            >
              <Link
                href={sector.link}
                className="block bg-white/5 p-6 rounded-xl border border-white/10 hover:border-primary/50 hover:bg-white/10 transition-all duration-300 cursor-pointer h-full group"
              >
                {/* Icon */}
                <div className="text-primary mb-4 group-hover:scale-110 group-hover:text-white transition-transform duration-300">
                  <Icon icon={sector.icon} width="32" />
                </div>

                {/* Title */}
                <h4 className="text-lg font-bold mb-2 text-white group-hover:text-primary transition-colors">
                  {sector.title}
                </h4>

                {/* Description */}
                <p className="text-sm text-foottext group-hover:text-white/80 transition-colors">
                  {sector.desc}
                </p>
              </Link>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
}
